<div class="termos">
  <div [formGroup]="parentForm" [hidden]="!menorDeIdade">
    <div formGroupName="representante">
      <fieldset class="fieldset-container">
        <legend>Dados do Representante</legend>

        <p class="info-text">
          Como o titular é menor de idade, insira os dados do responsável legal.
        </p>
        <div class="form-group full-width">
          @if (cpfRep) {
            <p id="minvalue">
              O cpf do Representante não pode ser o mesmo do Titular.
            </p>
          }
          <input
            formControlName="cpfRep"
            (input)="onUserCpfChange($event.target.value)"
            mask="000.000.000-00"
            placeholder="CPF "
            />
          </div>

          <div class="form-group full-width">
            <input
              formControlName="nomeRep"
              placeholder="Nome Completo "
              />
            </div>

            <div class="form-group full-width select">
              <select
                class="select-text"
                formControlName="codRepTipo"
                >
                <option disabled selected value=null>Parentesco</option>
                @for (tipo of tipoRepresentante; track tipo) {
                  <option [value]="tipo.COD_REP_TIPO">{{tipo.DCR_REP_TIPO}}</option>
                }
              </select>
            </div>

            <div class="form-group first-width">
              <input
                formControlName="telRep"
                mask="(00) 0 0000-0000"
                placeholder="Telefone"
                />
              </div>

              <div class="form-group last-width">
                <input
                  formControlName="emailRep"
                  type="email"
                  size="30"
                  placeholder="Email"
                  />
                </div>
              </fieldset>
            </div>
          </div>

          <div [formGroup]="parentForm">

            <div formGroupName="termos">

              <fieldset class="fieldset-container">

                <legend>Termos da Adesão</legend>

                <p class="info-text">
                  Termos da Adesão do titular
                </p>

                <div class="termos">
                  <div class="form-group form-check">
                    <input
                      [checked]="this.parentForm.get('termos.decLGPD').value === 'S'"
                      type="checkbox"
                      class="form-check-input"
                      (change)="this.parentForm.get('termos.decLGPD').setValue($event.target.checked ? 'S':'N')"/>
                      <label class="form-check-label" for="exampleCheck1">
                        Declaro para os devidos fins ter CIÊNCIA de que os dados pessoais
                        coletados no processo de adesão ao plano de benefícios setorial Viva
                        Mais Previdência estão de acordo com a finalidade, adequação e
                        necessidade, tendo como bases legais para tratamento a necessidade de
                        execução de contrato e o cumprimento de obrigações legais junto aos
                        órgãos reguladores, nos termos da Lei Geral de Proteção de Dados - LGPD
                      </label>
                    </div>
                  </div>

                  <div class="termos">
                    <div class="form-group form-check">
                      <input
                        [checked]="this.parentForm.get('termos.idcAutDadosPessoais').value === 'S'"
                        type="checkbox"
                        class="form-check-input"
                        (change)="this.parentForm.get('termos.idcAutDadosPessoais').setValue($event.target.checked ? 'S':'N')"/>
                        <label class="form-check-label" for="exampleCheck2">
                          ASSUMO a responsabilidade legal pelas informações prestadas neste
                          processo de adesão ao plano de benefício setorial Viva Mais Previdência,
                          DECLARANDO de forma irrevogável e irretratável que tive prévio acesso ao
                          <a href="https://arquivos.vivamaisprev.com.br/regulamento.pdf" target="blank">Regulamento do plano</a>, ao
                          <a href="https://arquivos.vivamaisprev.com.br/estatuto_fusan.pdf" target="blank">Estatuto da FUSAN</a> e ao
                          <a href="https://arquivos.vivamaisprev.com.br/cartilha_explicativa.pdf" target="blank"> Material Explicativo</a> do
                          plano de benefícios.
                        </label>
                      </div>
                    </div>


                    <div class="info">

                      <div class="form-group">
                        <div class="info-btn">
                          <p>VOCÊ É UM <strong>US PERSON </strong>?</p>
                          <button (click)="openOneModal()">
                            <small title="Saiba mais"><i class="fas fa-question-circle"></i></small>
                          </button>
                        </div>
                        <div class="form-check form-check-inline">
                          <label class="form-check-label">
                            <input
                              formControlName="decUSPerson"
                              class="form-check-input"
                              type="radio"
                              value="S"/>
                              SIM
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <label class="form-check-label">
                              <input
                                formControlName="decUSPerson"
                                class="form-check-input"
                                type="radio"
                                value="N"/>
                                NÃO
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="info-btn">
                              <p>VOCÊ É UMA <strong>PESSOA POLITICAMENTE EXPOSTA </strong>?</p>
                              <button (click)="openTwoModal()">
                                <small title="Saiba mais"><i class="fas fa-question-circle"></i></small>
                              </button>
                            </div>
                            <div class="form-check form-check-inline">
                              <label class="form-check-label">
                                <input
                                  formControlName="decPPE"
                                  class="form-check-input"
                                  type="radio"
                                  value="S"/>
                                  SIM
                                </label>
                              </div>
                              <div class="form-check form-check-inline">
                                <label class="form-check-label">
                                  <input
                                    formControlName="decPPE"
                                    class="form-check-input"
                                    type="radio"
                                    value="N"/>
                                    NÃO
                                  </label>
                                </div>
                              </div>

                              <div class="form-group">

                                <div class="info-btn">
                                  <p>POSSUI IDENTIFICAÇÃO FISCAL EM OUTROS PAÍSES (NIF)?</p>
                                  <button (click)="openthreeModal()">
                                    <small  title="Saiba mais"><i class="fas fa-question-circle"></i></small>
                                  </button>
                                </div>

                                <div class="form-check form-check-inline">
                                  <label class="form-check-label">
                                    <input
                                      formControlName="idcPais"
                                      class="form-check-input"
                                      (input)="verificaResidenciaFiscal($event.target.value)"
                                      type="radio"
                                      value="S"/>
                                      SIM
                                    </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                      <input
                                        formControlName="idcPais"
                                        class="form-check-input"
                                        (input)="verificaResidenciaFiscal($event.target.value)"
                                        type="radio"
                                        value="N"/>
                                        NÃO
                                      </label>
                                    </div>

                                    @if (newopt) {
                                      <form id="nif-option" [formGroup]="nifForm">
                                        <input
                                          formControlName="numNIF"
                                          type="text"
                                          placeholder="NIF"/>
                                          <select class="select-text" formControlName="dcrNacionalidade">
                                            <option selected disabled value="">Selecione a Nacionalidade</option>
                                            @for (item of nacionalidades; track item) {
                                              <option [value]="item.DCR_NACIONALIDADE" >{{item.DCR_NACIONALIDADE}}</option>
                                            }
                                          </select>
                                          <button
                                            id="include-btn"
                                            (click)="incluirNif()"
                                            class="btn btn_verde"
                                            [disabled]="!nifForm.valid">
                                            INCLUIR
                                          </button>
                                        </form>
                                      }

                                      @if (newopt) {
                                        <div>
                                          <ul id="nif-component">
                                            @for (item of nifs; track item) {
                                              <li style="display: flex; justify-content: space-evenly; align-items: center; background: #F5F5F5; padding: 12px 0 8px 0;">
                                                <p style="color: #8B8B8B">{{ item.NI }}</p>
                                                <p style="color: #8B8B8B">{{ item.DCR_NACIONALIDADE }}</p>
                                                <p (click)="removeNIF(item.DCR_NACIONALIDADE)">
                                                  <i style="font-size: 16px; margin: 0; cursor: pointer;" class="fas fa-times icone"></i>
                                                </p>
                                              </li>
                                            }
                                          </ul>
                                        </div>
                                      }

                                    </div>

                                  </div>
                                </fieldset>
                              </div>
                            </div>

                            @if (!tiponedisabled) {
                              <div class="info-modal">
                                <h2>O que é US Person</h2>
                                <p>Você é um US Person se possui alguma dessas características:</p>
                                <ul>
                                  <li>
                                    Cidadania norte-americana, incluido os dentetores de dupla nacionalidade
                                    e passaporte norte-americano, ainda que residam fora dos Estados Unidos
                                  </li>
                                  <li>
                                    Residência fiscal nos EUA, ou seja, que possuam Green Card e que possa
                                    se tornar um residente permanente legal.
                                  </li>
                                  <li>
                                    Presença física nos Estados Unidos para fins tributários por pelo menos:
                                    31 dias durante o ano corrente ou 183 dias nos últimos 3 anos.
                                  </li>
                                </ul>
                                <button (click)="closeOneModal()" class="info-button__close">x</button>
                              </div>
                            }

                            @if (!tiptwodisabled) {
                              <div class="info-modal">
                                <h2>O que é Pessoa Politicamente exposta (PPE) ?</h2>
                                <p>
                                  Pessoas Politicamente Expostas (PPE) são os agentes públicos que
                                  desempenham ou tenham desempenhado, nos últimos cinco anos, no Brasil ou
                                  em países, territórios e depêndencias estrageiros, cargos, empregos ou
                                  funções públicas relevantes, familiares e outras pessoas de seu
                                  relacionamento próximo.
                                </p>
                                <button (click)="closeTwoModal()" class="info-button__close">x</button>
                              </div>
                            }

                            @if (!tipthreedisabled) {
                              <div class="info-modal">
                                <h2>O que é NIF ?</h2>
                                <p>
                                  O "Número de Identificação Fiscal", também chamado de NIF,
                                  é o número fornecido pelo órgão de administração tributária no exterior indicador de pessoa física ou jurídica.
                                  Seria equivalente ao CPF, que identifica a pessoa física, ou ao CNPJ, que identifica a pessoa jurídica no Brasil.
                                </p>
                                <button (click)="closeThreeModal()" class="info-button__close">x</button>
                              </div>
                            }

                            <br />
                            <br />

                            <div [formGroup]="parentForm">

                              <h3>Vinculo ao Plano:</h3>

                              <div formGroupName="vinculo">

                                <div class="instituidor">
                                  <select formControlName="codVinculo" class="select-text" (change)="OncodInstituidorChange($event, $event.target.value)">
                                    <option value="Selecione" disabled value=null style="font-weight: bold;">Selecione sua forma de vinculação ao plano</option>

                                    @for (item of tiposVinculo; track item; let index = $index) {
                                      <option [attr.data-cod_instituidor]="item.COD_INSTITUIDOR" [attr.data-dec_mostra_vinculo]="item.DEC_MOSTRA_VINCULO" [value]="item.COD_VINCULO">
                                        {{item.DCR_VINCULO}}
                                      </option>
                                    }

                                  </select>
                                </div>

                                <br />

                                @if (this.parentForm.get('vinculo.codInstituidor').value != 3 && this.parentForm.get('vinculo.decMostraVinculo').value == 1) {
                                  <div class="vinculo">
                                    <h3>Insira os dados do seu vínculo familiar ou cônjuge deste:</h3>
                                    <div>
                                      <div class="form-group first-width">
                                        <input
                                          formControlName="nomeAssociado"
                                          placeholder="Nome"
                                          />
                                          @if (!nameError) {
                                            <small>Nome do participante Fusan ou cônjuge deste.</small>
                                          }
                                          @if (nameError) {
                                            <small
                                              ><b style="color: #cc1618; font-weight: 400;">Erro no campo nome! </b>
                                              nome valido.</small
                                              >
                                          }
                                        </div>
                                        <div class="form-group last-width">
                                          <input
                                            formControlName="sobrenomeAssociado"
                                            placeholder="Sobrenome"
                                            />
                                            @if (!sobrenomeError) {
                                              <small>Sobrenome do participante Fusan ou cônjuge deste.</small>
                                            }
                                            @if (sobrenomeError) {
                                              <small
                                                ><b style="color: #cc1618; font-weight: 400;"
                                                >Erro no campo sobrenome! </b
                                                >Digite um sobrenome valido.</small
                                                >
                                            }
                                          </div>
                                          <div class="form-group first-width select">
                                            <select
                                              formControlName="CodParentescoAssociado"
                                              class="select-text">
                                              <option value="Selecione" disabled value=null>Selecione o parentesco</option>
                                              @for (parent of parentescos; track parent) {
                                                <option [value]="parent.COD_PARENTESCO">{{parent.DCR_PARENTESCO_EXT}}</option>
                                              }
                                            </select>
                                          </div>
                                          <div class="form-group last-width">
                                            @if (cpfAssociado) {
                                              <p id="minvalue">
                                                O cpf do Representante não pode ser o mesmo do Titular.
                                              </p>
                                            }
                                            <input
                                              formControlName="cpfAssociado"
                                              (input)="onUserCPFChange($event.target.value)"
                                              mask="000.000.000-00"
                                              placeholder="CPF*"
                                              />
                                              <small>CPF do participante Fusan ou cônjuge deste.</small>
                                            </div>
                                            <div class="clearfix"></div>
                                          </div>
                                        </div>
                                      }

                                      @if (this.parentForm.get('vinculo.codInstituidor').value == 3 && this.parentForm.get('vinculo.decMostraVinculo').value == 1) {
                                        <div class="vinculo">
                                          <h3>Insira o número da sua carteirinha ASPP:</h3>
                                          <div class="">
                                            <input formControlName="dcrCarteiraAspp" (focus)="asppError=null" type="text" maxlength="6" placeholder="Número da Carteira"/>
                                            <div class="text-danger">{{asppError}}</div>
                                          </div>
                                        </div>
                                      }


                                    </div>
                                  </div>

                                  <div class="termos clearfix" style="margin-top: 26px;">
                                    <input
                                      id="idcTermoVinculo"
                                      [checked]="this.parentForm.get('vinculo.idcTermoVinculo').value == 'S'"
                                      (change)="onUserCheckChange($event.target.checked)"
                                      class="form-check-input"
                                      type="checkbox"
                                      />
                                      <label class="form-check-label" for="idcTermoVinculo">
                                        DECLARO para os devidos fins que as informações prestadas à FUSAN neste
                                        ato são verdadeiras, estando CIENTE da possibilidade do cancelamento
                                        unilateral da minha inscrição se verificada fraude ou incorreção dos
                                        dados apresentados.
                                      </label>
                                    </div>

                                  </div>



